import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
export function PromoPopup() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    return () => clearTimeout(timer);
  }, []);
  return <AnimatePresence data-id="element-179">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 80,
      scale: 0.95
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 80,
      scale: 0.95
    }} transition={{
      type: 'spring',
      damping: 25,
      stiffness: 300
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-180">
          <div className="bg-[#1A2744] border border-[#F4A535]/30 rounded-2xl p-4 shadow-[0_20px_60px_rgba(0,0,0,0.4)] relative overflow-hidden w-[85%] max-w-xs" data-id="element-181">
            <div className="absolute inset-0 bg-gradient-to-r from-[#F4A535]/5 to-transparent pointer-events-none" data-id="element-182" />

            <button onClick={() => setIsVisible(false)} className="absolute top-3 right-3 w-7 h-7 flex items-center justify-center rounded-full bg-white/10 hover:bg-white/20 transition-colors text-white/70 z-10" aria-label="Cerrar" data-id="element-183">
              <XIcon size={14} data-id="element-184" />
            </button>

            <div className="relative z-10 text-center" data-id="element-185">
              <p className="text-2xl mb-1" data-id="element-186">⏰</p>
              <h3 className="text-lg font-bold text-white mb-1" data-id="element-187">
                Precio especial por tiempo limitado
              </h3>
              <p className="text-sm text-[#B8C8E8] mb-4" data-id="element-188">
                Obtén el Pack Completo con{' '}
                <span className="text-[#F4A535] font-bold" data-id="element-189">
                  60% de descuento
                </span>{' '}
                antes de que termine la oferta.
              </p>
              <button onClick={() => {
            setIsVisible(false);
            document.getElementById('precio-cta')?.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            });
          }} className="inline-block bg-gradient-to-r from-[#F4A535] to-[#E8851A] text-[#1A2744] text-sm font-extrabold px-8 py-3 rounded-full shadow-[0_4px_15px_rgba(244,165,53,0.4)] transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_8px_25px_rgba(244,165,53,0.5)] cursor-pointer border-none" data-id="element-190">
                🚀 ¡Quiero la Oferta!
              </button>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}